const firebaseConfig = {
  apiKey: "AIzaSyBc50hdSGTBoztMGMPGTYWwJU0AoyDkarY",
  authDomain: "fir-auth2-ecb75.firebaseapp.com",
  projectId: "fir-auth2-ecb75",
  storageBucket: "fir-auth2-ecb75.appspot.com",
  messagingSenderId: "725933278302",
  appId: "1:725933278302:web:56673f5a61236232e360cf"
};

export default firebaseConfig;


